<template>

  <div class="image-card" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave" @click="toggleHover">
    <div class="image-container" :class="{ 'hovered': isHover || isClicked }">
      <img v-if="imageData.imageUrl != null" :src="imageData.imageUrl" alt="Image" loading="lazy">
      <video ref="videoRef" v-if="imageData.video != null" :src="imageData.video" id="video-container" width="100%"
                  controls ></video>
    </div>
    <p class="caption">{{ imageData.caption }} <i v-if="imageData.vid != null" class="fa-solid fa-video"></i>   </p>
    <p class="secondary-caption">{{ imageData.secondaryCaption }}</p>
    <div class="additional-info" v-if="isClicked">
      <div class="slide-container">
        <div class="slides" :style="{ transform: 'translateX(' + slideOffset + 'px)' }" ref="slideContainer">
          <div v-for="(slide, index) in imageData.secondaryImages" :key="index" class="slide">
            <div class="image-wrapper">
              <div>
                <!-- Video player component with source pointing to the imported .mp4 file -->
                <video ref="videoRef" v-if="slide.vidUrl != null" :src="slide.vidUrl" id="video-container" width="100%"
                  controls ></video>
              </div>
              <img v-if="slide.imageUrl != null" :src="slide.imageUrl" alt="Additional Image" loading="lazy">
            </div>
            <div v-if="slide.description != null" class="description">{{ slide.description }}</div>
          </div>
        </div>
      </div>
      <div class="scroll-button left" v-show="showLeftArrow" @click.stop="scrollLeft">
        <span>&lt;</span>
      </div>
      <div class="scroll-button right" v-show="showRightArrow" @click.stop="scrollRight">
        <span>&gt;</span>
      </div>

    </div>
  </div>
</template>
  
  <script>
  import data from 'D:/VueJs/test03/src/InteriorData.js'; // Import the data array from data.js
  
  export default {
    props: {
      image: Object
    },
    data() {
      return {
        isHover: false,
        isClicked: false,
        slideOffset: 0,
        showLeftArrow: false,
        showRightArrow: false,
        currentSlideIndex: 0
      };
    },
    computed: {
      // Use a computed property to get the main image data based on the prop
      imageData() {
        // Find the main image data
        const mainImageData = data.find(item => item.imageUrl === this.image.imageUrl);
  
        // If main image data is found, return it
        return mainImageData ? mainImageData : {};
      }
    },
    methods: {
      handleMouseEnter() {
        if (!this.isClicked) {
          this.isHover = true;
          this.showLeftArrow = true;
          this.showRightArrow = true;
        }
      },
      handleMouseLeave() {
        if (!this.isClicked) {
          this.isHover = false;
          this.showLeftArrow = false;
          this.showRightArrow = false;
        }
      },
      toggleHover() {
        if (!this.isClicked) {
          this.isClicked = true;
          this.showLeftArrow = true;
          this.showRightArrow = true;
        } else {
          this.isClicked = false;
          this.slideOffset = 0;
          this.currentSlideIndex = 0;
        }
      },
      scrollLeft() {
    if (this.currentSlideIndex < this.imageData.secondaryImages.length - 1) {
      this.currentSlideIndex++;
      this.slideOffset += this.$refs.slideContainer.clientWidth;
      // Adjust slideOffset to ensure it doesn't exceed boundaries
      this.slideOffset = Math.max(this.slideOffset, 0);
    }
  },
  scrollRight() {
    if (this.currentSlideIndex > 0) {
      this.currentSlideIndex--;
      this.slideOffset -= this.$refs.slideContainer.clientWidth;
      // Adjust slideOffset to ensure it doesn't exceed boundaries
      this.slideOffset = Math.max(this.slideOffset, -this.$refs.slideContainer.scrollWidth + this.$refs.slideContainer.clientWidth);
    }
  }
  
  
    }
  };
  </script>
  
  <style scoped>
  i{
    font-size: 10px;
  }
  /* Add styles for secondary caption */
  .image-card {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    transition: padding 0.3s ease;
    cursor: pointer;
    height: 100vh;
    margin-top: 80px; /* Adjust the margin to overlap with NavBar */
  margin-bottom: -50px; /* Adjust the margin to overlap with NavBar */
  }
  
  .image-container {
    flex-grow: 1;
    max-width: 60vw;
    max-height: 80vh;
    overflow: hidden;
    transition: max-width 0.5s ease, max-height 0.5s ease;
  }
  
  .image-container.hovered {
    max-width: calc(60vw - 5vw);
    max-height: calc(80vh - 2.5vh);
  }
  
  .image-container img {
    width: 100%;
    height: 100vh;
    object-fit: scale-down;
  }
  
  .caption {
    margin-top: 10px;
    font-size: 18px;
    text-align: center;
  }
  
  .secondary-caption {
    font-size: 16px;
    opacity: 0.7;
    margin-top: 5px;
    text-align: center;
  }
  
  .additional-info {
    position: absolute;
    top: 0;
    width: calc(100% - 40px); /* Adjusted to account for padding */
    height: calc(100% - 40px); /* Adjusted to account for padding */
    background-color: rgba(255, 255, 255, 1);
    overflow: hidden;
    padding: 20px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    transition: left 0.3s ease;
  }
  
  .slide-container {
    overflow: hidden;
    position: relative;
    width: 100vw; /* Set width to 100% of the viewport width */
    height: 100vh; /* Set height to 100% of the viewport height */
    direction: rtl;
  }
  .slides {
    display: flex;
    transition: transform 0.3s ease;
    direction: rtl;
  }
  
  .slide {
    flex: 0 0 auto;
    width: 100%; /* Adjusted to account for padding */
    height: 100vh;
    padding: 0px;
    box-sizing: border-box;
    text-align: center;
    display: flex;
    align-items: flex-start; /* Change align-items to flex-start */
    justify-content: center;
  }
  
  .image-wrapper {
    flex: 0 0 auto;
    width: 50%;
  }
  
  .slide img {
    max-width: 100%; /* Set maximum width to 100% of the container */
    max-height: 100%; /* Set maximum height to 100% of the container */
    width: 60vw; /* Allow the image to adjust its width based on the container */
    height: 80vh; /* Allow the image to adjust its height based on the container */
    margin-right: 30px;
    object-fit: scale-down;
  
  }
  .slide video {
    max-width: 100%; /* Set maximum width to 100% of the container */
    max-height: 100%; /* Set maximum height to 100% of the container */
    width: 60vw; /* Allow the image to adjust its width based on the container */
    height: 80vh; /* Allow the image to adjust its height based on the container */
    margin-right: 30px;
    object-fit: scale-down;
  
  }
  .description {
    text-align: right;
    padding:5%; /*Add padding to the left of the description */
    padding-right: 4%;
    padding-left: 10%;
    flex: 1; /* Allow description to expand to fill remaining space */
    direction: rtl; /* Set text direction to right-to-left */
    font-family: 'Iran Sans', sans-serif;
    font-size: 16px; /* Adjust font size as needed */
    line-height: 1.6; /* Set line height for better readability */
    
  }
  @media only screen and (max-width: 600px) {
  .slide {
  flex: 0 0 auto;
  width: 100%;
  /* Adjusted to account for padding */
  height: 100%;
  padding: 5%;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  align-items: flex-start;
  /* Change align-items to flex-start */
  justify-content: center;
}
  .slide img {
    max-width: 100%;
    /* Set maximum width to 100% of the container */
    max-height: 100%;
    /* Set maximum height to 100% of the container */
    width: 90vw;
    /* Allow the image to adjust its width based on the container */
    height: 65vh;
    /* Allow the image to adjust its height based on the container */
    object-fit: scale-down;

  }

  .tape {
    text-align: center;
    position: absolute;
    margin-top: 10%;
    background-color: rgba(232, 253, 140, 0.519);
    padding: 5px 20px;
    border-radius: 50px;
    /* Add round corners */
  }

  .image-wrapper {
    width: 100%;
  padding-right: 5vw;
  }
  .slide:nth-child(1){
    padding-right: 20vw;
}
  .description {
    margin-top: -1246vw;
  }

  .image-container {
    flex-grow: 1;
    max-width: 100vw;
    /* max-height: 60vh; */
    overflow: hidden;
  }

  .image-container.hovered {
    max-width: 100vw;
  }

  .image-container img {
    width: 100vw;
    height: 60vh;
    object-fit: scale-down;
  }

  .image-card {
    height: 70vh;
  }
}
  
  .scroll-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 30px;
    height: 30px;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    z-index: 1;
    border-radius: 50%; /* Added for a circular shape */
    transition: background-color 0.3s; /* Added for hover effect */
  }
  
  .scroll-button:hover {
    background-color: rgba(0, 0, 0, 0.7); /* Darken background on hover */
  }
  
  .scroll-button.left {
    left: 10px; /* Adjusted for better positioning */
  }
  
  .scroll-button.right {
    right: 10px; /* Adjusted for better positioning */
  }
  
  </style>